// Azure API Templates Configuration
// Defines which APIs have env variable templates and their API-specific form fields

export const AZURE_API_TEMPLATES = {
  'backend-backoffice-api': {
    hasTemplate: true,
    templateKey: 'backoffice',
    downloadSuffix: 'scus-app-api-env',
    extraFields: [],
  },
  'backend-auctionengine': {
    hasTemplate: true,
    templateKey: 'auctionengine',
    downloadSuffix: 'scus-app-auctionengine-env',
    extraFields: [
      { id: 'signalRConnectionString', label: 'SignalR Connection String *', type: 'text', placeholder: 'Endpoint=...;AccessKey=...' },
    ],
  },
  'backend-simulcast-api': {
    hasTemplate: true,
    templateKey: 'simulcast',
    downloadSuffix: 'simulcast-api-env',
    extraFields: [],
  },
  'backend-simulcast-auctionengine': {
    hasTemplate: true,
    templateKey: 'simulcast-auctionengine',
    downloadSuffix: 'simulcast-auctionengine-env',
    extraFields: [
      { id: 'signalRConnectionString', label: 'SignalR Connection String *', type: 'text', placeholder: 'Endpoint=...;AccessKey=...' },
    ],
  },
  'backend-company-api': {
    hasTemplate: true,
    templateKey: 'company',
    downloadSuffix: 'company-api-env',
    extraFields: [],
  },
  'backend-contacts-api': {
    hasTemplate: true,
    templateKey: 'contacts',
    downloadSuffix: 'contacts-api-env',
    extraFields: [],
  },
  'backend-inventory-api': {
    hasTemplate: true,
    templateKey: 'inventory',
    downloadSuffix: 'inventory-api-env',
    extraFields: [
      { id: 'tenantConnectionsValue', label: 'TenantConnections value *', type: 'text', placeholder: 'Connection string for TenantConnections:{tenantKey}' },
    ],
  },
};

// Auction Engine environment variables template
// Placeholders: {tenantName}, {APPINSIGHTS_INSTRUMENTATIONKEY}, {APPLICATIONINSIGHTS_CONNECTION_STRING},
// {CORS}, {SignalRConnectionString}, {CommandAuth:Key}, {CommandAuth:Secret}
export const AUCTION_ENGINE_ENV_TEMPLATE = [
  { name: 'APPINSIGHTS_INSTRUMENTATIONKEY', value: '{APPINSIGHTS_INSTRUMENTATIONKEY}', slotSetting: true },
  { name: 'APPLICATIONINSIGHTS_CONNECTION_STRING', value: '{APPLICATIONINSIGHTS_CONNECTION_STRING}', slotSetting: true },
  { name: 'ApplicationInsightsAgent_EXTENSION_VERSION', value: '~2', slotSetting: false },
  { name: 'CommandAuth:Key', value: '2128E1F7-2750-41AF-90E7-1AB1AA57A6DF', slotSetting: true },
  { name: 'CommandAuth:Secret', value: 'NNnwx99rVQzp9JcfRwPGNmpLyfJYPymzEmfzv6rMJVHeZ7THhdyJqbatqYaRWkqt3ah5kRFp44R5hF8uuMzFXXAPH9mFXpzVtDmR64ZFbpyfWGx47TA4WhfMHnBAqs9F', slotSetting: true },
  { name: 'CommandAuth:SellItem_URL', value: 'https://{tenantName}-scus-app-api.azurewebsites.net/api/v1', slotSetting: true },
  { name: 'CORS', value: '{CORS}', slotSetting: true },
  { name: 'Engine', value: 'Online', slotSetting: true },
  { name: 'InstrumentationEngine_EXTENSION_VERSION', value: 'disabled', slotSetting: true },
  { name: 'SignalR:Online', value: '{SignalRConnectionString}', slotSetting: true },
  { name: 'SnapshotDebugger_EXTENSION_VERSION', value: 'disabled', slotSetting: true },
  { name: 'WEBSITE_ENABLE_SYNC_UPDATE_SITE', value: 'true', slotSetting: false },
  { name: 'WEBSITE_NODE_DEFAULT_VERSION', value: '6.9.1', slotSetting: false },
  { name: 'WEBSITE_RUN_FROM_PACKAGE', value: '1', slotSetting: false },
  { name: 'XDT_MicrosoftApplicationInsights_BaseExtensions', value: 'disabled', slotSetting: true },
  { name: 'XDT_MicrosoftApplicationInsights_Mode', value: 'recommended', slotSetting: true },
  { name: 'XDT_MicrosoftApplicationInsights_NodeJS', value: '1', slotSetting: true },
  { name: 'XDT_MicrosoftApplicationInsights_PreemptSdk', value: 'disabled', slotSetting: true },
];

// Backend Company API environment variables template
// Placeholders: {tenantName}, {APPINSIGHTS_INSTRUMENTATIONKEY}, {APPLICATIONINSIGHTS_CONNECTION_STRING}, {CORS}
export const COMPANY_API_ENV_TEMPLATE = [
  { name: 'APPINSIGHTS_INSTRUMENTATIONKEY', value: '{APPINSIGHTS_INSTRUMENTATIONKEY}', slotSetting: true },
  { name: 'APPLICATIONINSIGHTS_CONNECTION_STRING', value: '{APPLICATIONINSIGHTS_CONNECTION_STRING}', slotSetting: true },
  { name: 'ApplicationInsightsAgent_EXTENSION_VERSION', value: '~2', slotSetting: false },
  { name: 'CORS', value: '{CORS}', slotSetting: true },
  { name: 'Environment', value: '{tenantName}', slotSetting: true },
  { name: 'WEBSITE_ENABLE_SYNC_UPDATE_SITE', value: 'true', slotSetting: false },
  { name: 'WEBSITE_RUN_FROM_PACKAGE', value: '1', slotSetting: false },
];

// Backend Contacts API environment variables template
// Same structure as Company API - placeholders: {tenantName}, {APPINSIGHTS_INSTRUMENTATIONKEY}, {APPLICATIONINSIGHTS_CONNECTION_STRING}, {CORS}
export const CONTACTS_API_ENV_TEMPLATE = [
  { name: 'APPINSIGHTS_INSTRUMENTATIONKEY', value: '{APPINSIGHTS_INSTRUMENTATIONKEY}', slotSetting: true },
  { name: 'APPLICATIONINSIGHTS_CONNECTION_STRING', value: '{APPLICATIONINSIGHTS_CONNECTION_STRING}', slotSetting: true },
  { name: 'ApplicationInsightsAgent_EXTENSION_VERSION', value: '~2', slotSetting: false },
  { name: 'CORS', value: '{CORS}', slotSetting: true },
  { name: 'Environment', value: '{tenantName}', slotSetting: true },
  { name: 'WEBSITE_ENABLE_SYNC_UPDATE_SITE', value: 'true', slotSetting: false },
  { name: 'WEBSITE_RUN_FROM_PACKAGE', value: '1', slotSetting: false },
];

// Backend Inventory API environment variables template
// Placeholders: {tenantName}, {APPINSIGHTS_INSTRUMENTATIONKEY}, {APPLICATIONINSIGHTS_CONNECTION_STRING},
// {AzureStorage:ConnectionString}, {CORS}, {TenantKey}
export const INVENTORY_API_ENV_TEMPLATE = [
  { name: 'APPINSIGHTS_INSTRUMENTATIONKEY', value: '{APPINSIGHTS_INSTRUMENTATIONKEY}', slotSetting: true },
  { name: 'APPLICATIONINSIGHTS_CONNECTION_STRING', value: '{APPLICATIONINSIGHTS_CONNECTION_STRING}', slotSetting: true },
  { name: 'ApplicationInsightsAgent_EXTENSION_VERSION', value: '~2', slotSetting: false },
  { name: 'AzureStorage:ConnectionString', value: '{AzureStorage:ConnectionString}', slotSetting: true },
  { name: 'CORS', value: '{CORS}', slotSetting: true },
  { name: 'Environment', value: '{tenantName}', slotSetting: true },
  { name: 'InstrumentationEngine_EXTENSION_VERSION', value: 'disabled', slotSetting: true },
  { name: 'SnapshotDebugger_EXTENSION_VERSION', value: 'disabled', slotSetting: true },
  { name: 'TenantConnections:{TenantKey}', value: '{TenantConnectionsValue}', slotSetting: true },
  { name: 'TenantKey', value: '{TenantKey}', slotSetting: true },
  { name: 'WEBSITE_ENABLE_SYNC_UPDATE_SITE', value: 'true', slotSetting: false },
  { name: 'WEBSITE_NODE_DEFAULT_VERSION', value: '6.9.1', slotSetting: false },
  { name: 'XDT_MicrosoftApplicationInsights_BaseExtensions', value: 'disabled', slotSetting: true },
  { name: 'XDT_MicrosoftApplicationInsights_Mode', value: 'recommended', slotSetting: true },
  { name: 'XDT_MicrosoftApplicationInsights_NodeJS', value: '1', slotSetting: true },
  { name: 'XDT_MicrosoftApplicationInsights_PreemptSdk', value: 'disabled', slotSetting: true },
];

// Backend Simulcast API environment variables template
// Placeholders: {tenantName}, {APPLICATIONINSIGHTS_CONNECTION_STRING}, {AzureStorage:ConnectionString},
// {AzureStorage:Key}, {CORS}, {StoreFrontURL}, {UseLegacyStoreFront}
export const SIMULCAST_API_ENV_TEMPLATE = [
  { name: 'APPLICATIONINSIGHTS_CONNECTION_STRING', value: '{APPLICATIONINSIGHTS_CONNECTION_STRING}', slotSetting: true },
  { name: 'ApplicationInsightsAgent_EXTENSION_VERSION', value: '~2', slotSetting: false },
  { name: 'AzureStorage:AccountName', value: '{tenantName}storagearea', slotSetting: true },
  { name: 'AzureStorage:BaseURL', value: 'https://{tenantName}storagearea.blob.core.windows.net', slotSetting: true },
  { name: 'AzureStorage:ConnectionString', value: '{AzureStorage:ConnectionString}', slotSetting: true },
  { name: 'AzureStorage:DocumentContainer', value: 'documents', slotSetting: true },
  { name: 'AzureStorage:ExportContainer', value: 'exports', slotSetting: true },
  { name: 'AzureStorage:ImportContainer', value: 'import', slotSetting: true },
  { name: 'AzureStorage:Key', value: '{AzureStorage:Key}', slotSetting: true },
  { name: 'AzureStorage:LogoContainer', value: 'logo', slotSetting: true },
  { name: 'AzureStorage:PhotoURL', value: 'https://{tenantName}storagearea.blob.core.windows.net/images/', slotSetting: true },
  { name: 'BackOfficeURL:{tenantName}', value: 'https://{tenantName}.platformhost.app/', slotSetting: true },
  { name: 'ClassicAuctionURL:{tenantName}', value: 'https://{tenantName}-storefront.platformhost.app/', slotSetting: true },
  { name: 'CORS', value: '{CORS}', slotSetting: true },
  { name: 'Environment', value: '{tenantName}', slotSetting: true },
  { name: 'EquifyAuctionsURL:{tenantName}', value: 'https://{tenantName}-storefront.platformhost.app/', slotSetting: true },
  { name: 'SendGrid_Key', value: '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', slotSetting: true },
  { name: 'SmartyStreets:AuthID', value: '2fb03cc1-fe46-813f-5358-1374880b5206', slotSetting: true },
  { name: 'SmartyStreets:AuthToken', value: 'NgG0ioWaAHIor7FWGnuS', slotSetting: true },
  { name: 'UseLegacyStoreFront', value: '{UseLegacyStoreFront}', slotSetting: true },
  { name: 'WEBSITE_ENABLE_SYNC_UPDATE_SITE', value: 'true', slotSetting: false },
  { name: 'WEBSITE_NODE_DEFAULT_VERSION', value: '6.9.1', slotSetting: false },
  { name: 'WEBSITE_RUN_FROM_PACKAGE', value: '1', slotSetting: false },
  { name: 'XDT_MicrosoftApplicationInsights_Mode', value: 'default', slotSetting: true },
];

// Backend Simulcast Auction Engine environment variables template
// Placeholders: {tenantName}, {APPLICATIONINSIGHTS_CONNECTION_STRING}, {AzureStorage:ConnectionString},
// {AzureStorage:Key}, {CORS}, {SignalRConnectionString}
export const SIMULCAST_AUCTION_ENGINE_ENV_TEMPLATE = [
  { name: 'APPLICATIONINSIGHTS_CONNECTION_STRING', value: '{APPLICATIONINSIGHTS_CONNECTION_STRING}', slotSetting: true },
  { name: 'ApplicationInsightsAgent_EXTENSION_VERSION', value: '~2', slotSetting: false },
  { name: 'AzureStorage:AccountName', value: '{tenantName}storagearea', slotSetting: true },
  { name: 'AzureStorage:BaseURL', value: 'https://{tenantName}storagearea.blob.core.windows.net', slotSetting: true },
  { name: 'AzureStorage:ConnectionString', value: '{AzureStorage:ConnectionString}', slotSetting: true },
  { name: 'AzureStorage:DocumentContainer', value: 'documents', slotSetting: true },
  { name: 'AzureStorage:ExportContainer', value: 'exports', slotSetting: true },
  { name: 'AzureStorage:ImportContainer', value: 'import', slotSetting: true },
  { name: 'AzureStorage:Key', value: '{AzureStorage:Key}', slotSetting: true },
  { name: 'AzureStorage:LogoContainer', value: 'logo', slotSetting: true },
  { name: 'AzureStorage:PhotoURL', value: 'https://{tenantName}storagearea.blob.core.windows.net/images/', slotSetting: true },
  { name: 'BackOfficeURL:{tenantName}', value: 'https://{tenantName}.platformhost.app/', slotSetting: true },
  { name: 'ClassicAuctionURL:{tenantName}', value: 'https://{tenantName}-storefront.platformhost.app/', slotSetting: true },
  { name: 'CommandAuth:Key', value: '2128E1F7-2750-41AF-90E7-1AB1AA57A6DF', slotSetting: true },
  { name: 'CommandAuth:Secret', value: 'NNnwx99rVQzp9JcfRwPGNmpLyfJYPymzEmfzv6rMJVHeZ7THhdyJqbatqYaRWkqt3ah5kRFp44R5hF8uuMzFXXAPH9mFXpzVtDmR64ZFbpyfWGx47TA4WhfMHnBAqs9F', slotSetting: true },
  { name: 'CommandAuth:SellItem_URL', value: 'https://{tenantName}-scus-app-api.azurewebsites.net/api/v1', slotSetting: true },
  { name: 'CORS', value: '{CORS}', slotSetting: true },
  { name: 'Engine', value: 'Simulcast', slotSetting: true },
  { name: 'Environment', value: '{tenantName}', slotSetting: true },
  { name: 'SendGrid_Key', value: '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', slotSetting: true },
  { name: 'SignalR', value: '{SignalRConnectionString}', slotSetting: true },
  { name: 'SimulcastURL:{tenantName}', value: 'https://{tenantName}-auction.platformhost.app/', slotSetting: true },
  { name: 'WEBSITE_ENABLE_SYNC_UPDATE_SITE', value: 'true', slotSetting: false },
  { name: 'WEBSITE_NODE_DEFAULT_VERSION', value: '6.9.1', slotSetting: false },
  { name: 'WEBSITE_RUN_FROM_PACKAGE', value: '1', slotSetting: false },
  { name: 'XDT_MicrosoftApplicationInsights_Mode', value: 'default', slotSetting: true },
];
